import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Icon from '../components/Icon';
import PageHeader from '../components/PageHeader';
import { relativeDayLabel, toISODate } from '../lib/dates';
import { clockTime } from '../lib/format';
import { useApp, useAppPath } from '../lib/AppContext';

// The bell, newest first: coach mode and the personal app each list their own (`audience`). Opening the list
// marks that side's notifications read.
export default function NotificationsPage({ audience = 'personal' }) {
  const { api, setUnreadBySide } = useApp();
  const path = useAppPath();
  const navigate = useNavigate();
  const [entries, setEntries] = useState(null);
  const [more, setMore] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/notifications?audience=${audience}`).then((data) => {
      setEntries(data.entries);
      setMore(data.more);
      setUnreadBySide(data.unread_by_side);
      if (data.unread_by_side?.[audience] > 0) {
        api.post('/notifications/read', { audience }).then((r) => setUnreadBySide(r.unread_by_side)).catch(() => {});
      }
    }).catch((e) => setError(e.message));
  }, [api, audience, setUnreadBySide]);

  const loadMore = async () => {
    const data = await api.get(`/notifications?audience=${audience}&before=${entries[entries.length - 1].id}`);
    setEntries((list) => [...list, ...data.entries]);
    setMore(data.more);
  };

  return (
    <div className="flex flex-col gap-3">
      <PageHeader title="Thông báo" fallback={audience === 'coach' ? '/coach' : '/'} />
      {error && <div role="alert" className="rounded-[20px] bg-[#fdebe4] p-4 text-sm text-[#8e3414]">{error}</div>}
      {!entries && !error && <div className="flex flex-col gap-2" aria-busy="true">{[0, 1, 2].map((i) => <div key={i} className="skeleton h-16 rounded-[16px]" />)}</div>}
      {entries?.length === 0 && <p className="rounded-[20px] bg-base-100 p-5 text-sm text-muted">Chưa có thông báo nào.</p>}
      {entries?.length > 0 && (
        <ul className="divide-y divide-line rounded-[20px] bg-base-100 px-4">
          {entries.map((n) => (
            <li key={n.id}>
              <button type="button" className="flex w-full items-start gap-3 py-3 text-left" disabled={!n.link_path}
                onClick={() => navigate(path(n.link_path))}>
                <span className={`mt-1.5 size-2 shrink-0 rounded-full ${n.read ? 'bg-transparent' : 'bg-error'}`} aria-label={n.read ? undefined : 'Chưa đọc'} />
                <span className="min-w-0 flex-1">
                  <span className="block text-[15px] font-semibold">{n.title}</span>
                  {n.body && <span className="block text-sm text-muted">{n.body}</span>}
                  <span className="block text-xs text-muted">{relativeDayLabel(toISODate(new Date(n.created_at)))} · {clockTime(n.created_at)}</span>
                </span>
                {n.link_path && <Icon name="chevronRight" className="mt-1 size-4 shrink-0 text-muted" />}
              </button>
            </li>
          ))}
        </ul>
      )}
      {more && <button type="button" className="btn btn-ghost h-11 rounded-2xl" onClick={loadMore}>Xem thêm</button>}
    </div>
  );
}
